import { createSelector } from 'reselect'

import * as networkSelectors from 'src/store/selectors/network'

export const gradeSnapshotEnabledSelector = createSelector(
  networkSelectors.networkFeatureEnabledFactory(':grade-snapshot'),
  networkEnabled => networkEnabled
)
